import React from "react";
import { Route, Switch } from "react-router-dom";
import DefaultLayoutRoute from "./components/DefaultLayout/DefaultLayoutRoute";
import { NotificationContainer } from "react-notifications";
import "react-datepicker/dist/react-datepicker.css";
import HomePage from "./pages/landingPage/home";
import ViewPaper from "./components/newpaperCrads/PublicationPage";
// import Login from './pages/Access/login.jsx';
import CreateAccount from "./pages/Access/createAccount.jsx";
import ForgotPassword from "./pages/Access/forgotPassword.jsx";
import VerifyAccount from "./pages/Access/verifyAccount.jsx";
import { CartContextProvider } from "./context/newsPaperContext";
import { UserDataProvider } from "./context/userContext";
import { SocketDataProvider } from "./context/socketContext";
import { PaymentProvider } from "./context/paymentContext";
import { ContextWrapStateProvider } from "./context/contextHandler";

import ShowCart from "./components/carts/cart";
import Profile from "./pages/userProfile/user";
import Review from "./pages/userProfile/reviews";
import Subscription from "./pages/userProfile/subscriptions";
import BookMarks from "./pages/userProfile/bookmarks";
import SubAccount from "./pages/userProfile/subAccount";
import Devices from "./pages/userProfile/devices";
import ViewPdf from "./pdfViewer/view";
import PaidPublications from "./components/pdfViewer/pdfViewer";
import Subscrptions from "./pages/subscriptions/mySubs";
import PublicPublicationAccess from "./components/newpaperCrads/PublicationPage";
import EditionPage from "./components/newpaperCrads/EditionPage";
import InputNewPassword from "./pages/Access/newPassword";
import Transations from "./pages/transations/userTransation";
import DisableInspect from "./components/helpers/disableInspect";
import ChangeOfName from "./pages/changeOfName/index";
import ChangeOfNameForm from "./pages/changeOfName/formerName";
import ChangeOfNameApplicaion from "./pages/changeOfName/applications";
import Applications from "./pages/changeOfName/allApplications";
import LoginV2 from "./pages/Access/loginv2";
import CreateAccountV2 from "./pages/Access/createAccountV2";
import Achive from "./pages/archive/ArchiveHome";
import MyLibrary from "./pages/library/MyLibrary";
import Account from "./pages/account/Account";
import DisabledItemsProvider from "./context/DisabledItemsContext";
import RedeemCard from "./pages/Coupon/RedeemCard.jsx";
import ConLanding from "./pages/changeOfName/ConLanding";
import ConApply from "./pages/changeOfName/ConApply";
import InstallPrompt from "./components/Install/InstallPrompt";
import SupportWidget from "./components/Support/SupportWidget";
import helpReader from "./components/Support/helpReader";

// Old account addresses open the new account hub (keeps links and bookmarks working).
function HubRedirect({ to }) {
  React.useEffect(() => { window.location.replace(to + window.location.search); }, [to]);
  return null;
}


function App(props) {
  const live =
    process.env.REACT_APP_BASE_URL == "https://api.thenewspaperstand.com"
      ? true
      : false;

  if (live) {
    if (window.innerWidth > 800) {
      DisableInspect();
    }

    console.log = function () {};
  }

  return (
    <React.Fragment>
      <NotificationContainer />
      <InstallPrompt />
      {/* Help & support (2026-10-28): signed-in readers only; hidden inside the full-screen reader and on sign-in pages. */}
      <SupportWidget side="reader" tokenKey="token" help={helpReader}
        hideOn={[/^\/view_single_paper\//, /^\/view_paper\//, /^\/(login|create_account|forgot_password|reset_password|verify_user_account)(\/|$)/]} />
      <Switch>
        {/* Old email opt-out link (never worked: ids were swapped). Renewal on/off lives in My account (QA 2026-10-26). */}
        <Route exact path="/cancel_subscription" component={() => <HubRedirect to="/account/subscriptions" />} />
        <Route exact path="/login" component={LoginV2} />
        <Route exact path="/forgot_password" component={ForgotPassword} />
        <Route exact path="/reset_password/:id" component={InputNewPassword} />
        <Route exact path="/create_account" component={CreateAccountV2} />
        <Route exact path="/create_account" component={CreateAccount} />

        <Route
          exact
          path="/verify_user_account/:id"
          component={VerifyAccount}
        />
        <ContextWrapStateProvider>
          <DisabledItemsProvider>
            <UserDataProvider>
              <PaymentProvider>
                <SocketDataProvider>
                  <CartContextProvider>
                    <DefaultLayoutRoute exact path="/" component={HomePage} />
                    <DefaultLayoutRoute
                      exact
                      path="/applications"
                      component={() => <HubRedirect to="/account/applications" />}
                    />
                    <DefaultLayoutRoute
                      exact
                      path="/changeofname"
                      component={ConLanding}
                    />
                    <DefaultLayoutRoute
                      exact
                      path="/changeofname/apply/:id"
                      component={ConApply}
                    />
<DefaultLayoutRoute
                      exact
                      path="/change_of_name_tab1/:id"
                      component={ChangeOfNameForm}
                    />
                    {/* Public notices are switched off for readers (QA 2026-10-26). */}
                    <DefaultLayoutRoute
                      exact
                      path="/public_notice"
                      component={() => <HubRedirect to="/" />}
                    />
                    <DefaultLayoutRoute
                      exact
                      path="/home"
                      component={HomePage}
                    />
                    <DefaultLayoutRoute
                      exact
                      path="/view_paper/:id"
                      component={ViewPaper}
                    />
                    <DefaultLayoutRoute
                      exact
                      path="/carts"
                      component={ShowCart}
                    />
                    <DefaultLayoutRoute
                      exact
                      routeType="Withprofile"
                      path="/user_profile"
                      component={() => <HubRedirect to="/account/settings" />}
                    />
                    <DefaultLayoutRoute
                      exact
                      routeType="Withprofile"
                      path="/reviews"
                      component={Review}
                    />
                    <DefaultLayoutRoute
                      exact
                      routeType="Withprofile"
                      path="/user/subscription"
                      component={Subscription}
                    />
                    {/* Old Following page (2026-10-28): followed papers live in My library → Following. */}
                    <Route
                      exact
                      path="/following"
                      component={() => <HubRedirect to="/account/library?tab=following" />}
                    />
                    <DefaultLayoutRoute
                      exact
                      routeType="Withprofile"
                      path="/bookmarks"
                      component={BookMarks}
                    />
                    <DefaultLayoutRoute
                      exact
                      routeType="Withprofile"
                      path="/sub_accounts"
                      component={() => <HubRedirect to="/account/gifts" />}
                    />
                    <DefaultLayoutRoute
                      exact
                      routeType="Withprofile"
                      path="/devices"
                      component={Devices}
                    />
                    <DefaultLayoutRoute
                      exact
                      path="/view_publication/:id"
                      component={PaidPublications}
                    />
                    <DefaultLayoutRoute
                      exact
                      routeType="pdf"
                      path="/view_single_paper/:id"
                      component={ViewPdf}
                    />
                    {/* <DefaultLayoutRoute
                      exact
                      routeType="pdf"
                      path="/subscription"
                      component={() => <HubRedirect to="/account/subscriptions" />}
                    /> */}
                    <DefaultLayoutRoute
                      exact
                      routeType="pdf"
                      path="/publication/:id"
                      component={PublicPublicationAccess}
                    />
                    <DefaultLayoutRoute
                      exact
                      routeType="pdf"
                      path="/publication/:id/:date"
                      component={EditionPage}
                    />
                    <DefaultLayoutRoute
                      exact
                      routeType="Withprofile"
                      path="/transations"
                      component={() => <HubRedirect to="/account/payments" />}
                    />

                    <DefaultLayoutRoute
                      exact
                      routeType=""
                      path="/archive"
                      component={Achive}
                    />
<DefaultLayoutRoute
                      exact
                      routeType=""
                      path="/account/subscriptions"
                      component={Account}
                    />
<DefaultLayoutRoute
                      exact
                      routeType=""
                      path="/account/payments"
                      component={Account}
                    />
<DefaultLayoutRoute
                      exact
                      routeType=""
                      path="/account/settings"
                      component={Account}
                    />
<DefaultLayoutRoute
                      exact
                      routeType=""
                      path="/account/gifts"
                      component={Account}
                    />
<DefaultLayoutRoute
                      exact
                      routeType=""
                      path="/account/applications"
                      component={Account}
                    />
<DefaultLayoutRoute
                      exact
                      routeType=""
                      path="/account/bills"
                      component={Account}
                    />
<DefaultLayoutRoute
                      exact
                      routeType=""
                      path="/account/library"
                      component={Account}
                    />
<DefaultLayoutRoute
                      exact
                      routeType=""
                      path="/account"
                      component={Account}
                    />
<DefaultLayoutRoute
                      exact
                      routeType=""
                      path="/library"
                      component={Account}
                    />
                    <DefaultLayoutRoute
                      exact
                      routeType=""
                      path="/coupon/redeem-card"
                      component={RedeemCard}
                    />
                  </CartContextProvider>
                </SocketDataProvider>
              </PaymentProvider>
            </UserDataProvider>
          </DisabledItemsProvider>
        </ContextWrapStateProvider>
      </Switch>
    </React.Fragment>
  );
}

export default App;
